let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lACXG")).then(() => parcelRequire('k3QR4'));